import { PreviewState } from 'editor/src/store/editorModules/preview/types';

const resetSpreadPreviewReducer = (state: PreviewState) => {
  state.spreadPreview = {};
};

export default resetSpreadPreviewReducer;
